<template>
  <div>
       <folded-panel :infoName=title>
        <div slot="content">
          <edit-data-table
            ref="formTable"
            :head="tableHead"
            :data.sync="tableData"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="editable"
            :showAdd="showAdd"
            height=""
          >
            <template #toolbar="{row}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="del(row)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
// import DataBox from "@/components/dynamic-form/dynamic-data-box";
export default {
    props: {
        title: String,
        tableHead: Array,
        tableData: Array,
        editable: Boolean,
        showAdd: Boolean
  },
  components: {
    FoldedPanel,
    // DataBox
  },
   methods: {
       del(row) {
        //    this.$emit('delRow',index)
        this.resf.formTable.remove(row)
       }
   }

}
</script>

<style>

</style>